import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import qs from '../utils/query';
import { isNotEmptyString, isPositiveInteger } from '../utils/validators';

export default class MessageApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('message'), options);
  }

  public ListMessages(roomId: string | number, { offset, limit }: any = {}) {
    const params: any = {};
    if (isPositiveInteger(offset)) {
      params.offset = offset;
    }
    if (isPositiveInteger(limit)) {
      params.limit = limit;
    }
    return this.get(
      `/message/v2/room/${roomId}/message`,
      qs.stringify(params, true),
    );
  }

  public CreateMessage(
    roomId: string | number,
    message?: any,
    { silent }: any = {},
  ) {
    const params: any = { message };
    if (silent) {
      params.silent = true;
    }
    return this.post(`/message/v2/room/${roomId}/message`, params);
  }

  public ListRecipients({
    entityId,
    recipientId,
    recipientNameLike,
    roomType,
    offset,
    limit,
  }: any = {}) {
    const params: any = {};

    if (isPositiveInteger(recipientId)) {
      params.org_id_in = [recipientId];
    }

    if (isNotEmptyString(recipientNameLike)) {
      params.org_like_namelegal = recipientNameLike;
    }

    if (isPositiveInteger(entityId)) {
      params.entity_id = entityId;
    }

    if (isPositiveInteger(offset)) {
      params.offset = offset;
    }

    if (isPositiveInteger(limit)) {
      params.limit = limit;
    }

    const query = `/message/v2/recipient/${roomType}`;
    return this.get(query, qs.stringify(params, true));
  }

  public ListRooms({ entityId, roomType, offset, limit }: any = {}) {
    const params: any = {};

    if (isPositiveInteger(entityId)) {
      params.entity_id = entityId;
    }

    if (isPositiveInteger(offset)) {
      params.offset = offset;
    }

    if (isPositiveInteger(limit)) {
      params.limit = limit;
    }

    const query = `/message/v2/room/${roomType}`;
    return this.get(query, qs.stringify(params, true));
  }

  public GetRoom({ roomType, roomId }: any = {}) {
    if (!isPositiveInteger(roomId)) {
      const error = {
        message:
          'Missing or wrong parameter: roomId (must be positive integer)',
        name: 'bad parameter',
      };
      throw error;
    }

    const query = `/message/v2/room/${roomType}/${roomId}`;
    return this.get(query);
  }

  public CreateRoom(
    organizationId: number,
    {
      message,
      entityId,
      roomType,
    }: {
      message?: string;
      entityId?: number | string;
      roomType: string;
    },
  ) {
    const params: {
      organization_id: number;
      entity_id?: number | string;
      message?: string;
    } = {
      organization_id: organizationId,
    };

    if (isPositiveInteger(entityId)) {
      params.entity_id = entityId;
    }

    if (isNotEmptyString(message)) {
      params.message = message;
    }

    const query = `/message/v2/room/${roomType}`;
    return this.post(query, params);
  }

  public AcknowledgeRoom(roomId: number | string) {
    return this.get(`/message/v2/room/${roomId}/ack`);
  }

  public RoomEntityCountUnacked(
    roomType: number | string,
    entityType: string,
    entityId: number | string,
    recipientIds: number[] | null = null,
  ) {
    const params = {
      entity_id: entityId,
      entity_type: entityType,
      ...(recipientIds && { recipient_ids: recipientIds }),
    };
    return this.get(
      `/message/v2/room/${roomType}/entity/unacked`,
      qs.stringify(params, true),
    );
  }

  public OrganizationCountUnacked() {
    return this.get('/message/v2/room/organization/unacked');
  }
}
